/** THIS IS AN AUTO GENERATED FILE, DO NOT EDIT MANUALLY -- Created by @graphql-codegen */
import * as Types from '../../../shared/generated.types'

import { api } from '../../../utils'
export const ServiceCategoryFragment = `
    fragment ServiceCategoryFragment on ServiceCategory {
  code
}
    `
export const ReferenceFragment = `
    fragment ReferenceFragment on Reference {
  _id
  type
  display
}
    `
export const AnnotationFragment = `
    fragment AnnotationFragment on Annotation {
  authorReference {
    ...ReferenceFragment
  }
  time
  text
}
    `
export const ScheduleFragment = `
    fragment ScheduleFragment on Schedule {
  _id
  active
  serviceCategory {
    ...ServiceCategoryFragment
  }
  actors {
    _id
    type
    display
  }
  reoccuranceTemplate {
    timezone
    reoccuranceType
    occuranceCount
    planningHorizon {
      startDate
      endDate
    }
    weeklyTemplate {
      offset
      interval
      dayTimes {
        startTime
        endTime
        dayOfWeek
      }
    }
  }
  notes {
    ...AnnotationFragment
  }
}
    `
export const ReoccuranceTemplateFragment = `
    fragment ReoccuranceTemplateFragment on ReoccuranceTemplate {
  id
  timezone
  reoccuranceType
  occuranceCount
  planningHorizon {
    startDate
    endDate
  }
  weeklyTemplate {
    offset
    interval
    dayTimes {
      startTime
      endTime
      dayOfWeek
    }
  }
  lastOccuranceIndex
}
    `
export const ServiceTypeFragment = `
    fragment ServiceTypeFragment on ServiceType {
  code
}
    `
export const VirtualServiceFragment = `
    fragment VirtualServiceFragment on VirtualService {
  channelType
  addressUrl
  phoneNumber
  sessionKey
}
    `
export const AppointmentFragment = `
    fragment AppointmentFragment on Appointment {
  _id
  status
  appointmentType
  description
  startDate
  endDate
  minutesDuration
  occuranceChanged
  occuranceIndex
  reoccuranceTemplate {
    ...ReoccuranceTemplateFragment
  }
  cancelationReason
  replacesAppointmentId
  createdDate
  serviceCategory {
    ...ServiceCategoryFragment
  }
  serviceType {
    ...ServiceTypeFragment
  }
  notes {
    ...AnnotationFragment
  }
  virtualService {
    ...VirtualServiceFragment
  }
  participants {
    actor {
      ...ReferenceFragment
    }
    type {
      code
    }
    required
    status
  }
  identifiers {
    source
    value
  }
  syncMessage
}
    `
export const AppointmentWarningFragment = `
    fragment AppointmentWarningFragment on AppointmentWarning {
  startDate
  endDate
  message
  code
}
    `
export const CreateAppointmentResponseFragment = `
    fragment CreateAppointmentResponseFragment on CreateAppointmentResponse {
  appointment {
    ...AppointmentFragment
  }
  warnings {
    ...AppointmentWarningFragment
  }
}
    `
export const CreateAppointmentExternalDocument = `
    mutation createAppointmentExternal($content: CreateAppointmentExternalInput!) {
  createAppointmentExternal(content: $content) {
    ...CreateAppointmentResponseFragment
  }
}
    ${CreateAppointmentResponseFragment}
${AppointmentFragment}
${ReoccuranceTemplateFragment}
${ServiceCategoryFragment}
${ServiceTypeFragment}
${AnnotationFragment}
${ReferenceFragment}
${VirtualServiceFragment}
${AppointmentWarningFragment}`
export const UpdateAppointmentExternalDocument = `
    mutation updateAppointmentExternal($id: ID!, $content: UpdateAppointmentExternalInput!) {
  updateAppointmentExternal(_id: $id, content: $content) {
    ...AppointmentFragment
  }
}
    ${AppointmentFragment}
${ReoccuranceTemplateFragment}
${ServiceCategoryFragment}
${ServiceTypeFragment}
${AnnotationFragment}
${ReferenceFragment}
${VirtualServiceFragment}`

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    createAppointmentExternal: build.mutation<
      Types.CreateAppointmentExternal,
      Types.CreateAppointmentExternalVariables
    >({
      query: (variables) => ({
        document: CreateAppointmentExternalDocument,
        variables,
      }),
    }),
    updateAppointmentExternal: build.mutation<
      Types.UpdateAppointmentExternal,
      Types.UpdateAppointmentExternalVariables
    >({
      query: (variables) => ({
        document: UpdateAppointmentExternalDocument,
        variables,
      }),
    }),
  }),
})

export { injectedRtkApi as api }
